<template>
    <div
        class="highlight"
    >
        <img :src="layout.image"/>
        <div
            class="sizer"
        >
            <div class="caption">
                <div class="caption-gabarit">
                    <div class="text" v-html="layout.description"/>
                    <Cta
                        :type="'router-link'"
                        :to="$trl({
                            name: layout.link
                        })"
                        class="link"
                    >   {{layout.caption}}
                    </Cta>
                </div>
            </div>
            <div class="baseline">
                <div class="text">
                    <div class="text-sizer" ref="sizer">
                        <h1
                            ref="oBaseline"
                            class="o-basline baseline-text"
                            v-html="layout.baseline"
                        />
                        <svg
                            ref="svg"
                            width="100%"
                            height="100%"
                            :viewBox="viewBox"
                        >
                            <foreignObject
                                x="0"
                                y="0"
                                :width="width"
                                :height="height"
                            >
                                <h1
                                    ref="baseline"
                                    class="baseline-text"
                                    v-html="layout.baseline"
                                />
                            </foreignObject>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            viewBox: '0 0 0 0',
            width: 0,
            height: 0
        }
    },
    mounted() {
        this.handleResize()
    },
    methods: {
        handleResize() {
            const width = this.$refs.oBaseline.offsetWidth
            const height = this.$refs.oBaseline.offsetHeight
            this.width = width
            this.height = height
            this.viewBox = `0 0 ${width} ${height}`
        }
    }

}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.highlight
    margin-top: 10%
    margin-bottom: 10%
.text-sizer
    width: 100%
    height: 100%
    display: flex
    align-items: center
.caption
    margin-left: 0
    padding-top: 12%
    width: 50%
    margin-right: -12%
    padding-right: 12%
    box-sizing: content-box
    @include media-breakpoint-down($lg)
        width: 100%
        padding-left: 9.6%
        padding-right: 9.6%
        box-sizing: border-box
    .text
        padding-right: 10.41667% * .875
        @include media-breakpoint-down($lg)
            padding-right: 0
.caption-gabarit
    width: auto
    max-width: 47em
    margin-left: 9.6% * 2
    margin-right: 0

    @include media-breakpoint-up($xxl)
        margin-left: auto
    @include media-breakpoint-down($lg)
        margin-left: 9.6%
        margin-right: 9.6%
    @include media-breakpoint-down($sm)
        margin-left: 0%
        margin-right: 0%

.cta
    margin-top: 8%
    border: 1px solid #e5e5e5
.baseline
    width: 50%
    position: relative
    @include media-breakpoint-down($lg)
        width: 100%
        overflow: hidden
    .text
        background-color: #ff0010
        padding-left: 14%
        padding-right: 10%
        padding-bottom: 29%
        padding-top: 29%
        margin-top: -29%
        height: 100vh
        overflow: hidden
        position: relative
        @include media-breakpoint-down($hd)
            height: auto
        @include media-breakpoint-down($lg)
            margin-top: 0%
        h1
            color: #ffffff
            display: inline-block
            font-size: 160px
.o-basline
    opacity: 0
    position: absolute
.sizer
    display: flex
    @include media-breakpoint-down($lg)
        flex-direction: column-reverse

img
    width: 100%
    height: auto
    display: block

</style>
